import { scopedKey } from "@/queries/scope";
import { observedRead, type THintTargets } from "./types";

/**
 * The workspace catalog's hint rows (NG-2802).
 */
export const CATALOG_HINTS: THintTargets = {
  // Every cached category read in the workspace: the fields and each field's
  // values, all keyed under `categories`.
  "categories:bank": observedRead((scope) => scopedKey(scope, "categories")),
  // Every cached custom-field read in the workspace: the bank, each field's
  // usage and the settings table's pages, all keyed under `custom-fields`.
  "custom-fields:bank": observedRead((scope) => scopedKey(scope, "custom-fields")),
  // Every cached skill read in the workspace: the bank, each skill's holders,
  // each member's skills, the signed-in member's own and the settings table's
  // pages, all keyed under `skills`. A holder change also sends a `members:bank` hint, which the
  // members domain's row answers.
  "skills:bank": observedRead((scope) => scopedKey(scope, "skills")),
  // Every cached job-role read in the workspace: the list, the pickers'
  // options, each role's members and the signed-in member's own, all keyed
  // under `job-roles`. A holding change also sends a `members:bank` hint.
  "job-roles:bank": observedRead((scope) => scopedKey(scope, "job-roles")),
};
